import { render, staticRenderFns } from "./tsjy.vue?vue&type=template&id=e50f3cc6&scoped=true&"
import script from "./tsjy.vue?vue&type=script&lang=js&"
export * from "./tsjy.vue?vue&type=script&lang=js&"
import style0 from "./tsjy.vue?vue&type=style&index=0&id=e50f3cc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50f3cc6",
  null
  
)

export default component.exports